import { z } from 'zod';

export const SOCIAL_CHALLENGE_STATUS_FILTERS = [
  'ready',
  'generating',
  'failed',
  'none',
  'generated',
] as const;

export const listSocialChallengesV1RequestSchema = z.object({
  query: z.string().optional(),
  status: z.enum(SOCIAL_CHALLENGE_STATUS_FILTERS).optional(),
  collectionId: z.number().optional(),
  minClips: z.number().optional(),
  maxClips: z.number().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
});

export type IListSocialChallengesV1Request = z.infer<typeof listSocialChallengesV1RequestSchema>;
